import { CHECKOUT_DISABLED } from '~~/constants/checkout';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

export const isCheckoutDisabled = (countryCode: CountryCodeValue): boolean => {

  return CHECKOUT_DISABLED.includes(countryCode) || false;

};
